import type {Config,Provider} from './shared.js';
import type {ReownConnection} from './wallet/reown-connection.js';

// AppKit owns wallet discovery and UI; keep only the product authentication bridge.
export function createWalletSelector(config:Config,onChange:()=>void=()=>{}){
 let client:ReownConnection|undefined,loading:Promise<ReownConnection>|undefined;
 const storageKey='shouju.reown.connected';
 const remember=(value:boolean)=>{try{if(value)localStorage.setItem(storageKey,'1');else localStorage.removeItem(storageKey)}catch{}};
 async function load(){
  if(client)return client;
  if(!config.walletConnect?.projectId)throw Error('钱包连接服务尚未配置，请稍后重试或使用邮箱登录。');
  if(!loading){const path='/reown-wallet.js';loading=import(path).then(module=>module.createReownWallet(config,onChange)).then(value=>client=value).finally(()=>{loading=undefined})}
  return loading;
 }
 return {
  provider:():Provider|undefined=>client?.provider(),
  async choose(){return (await load()).choose()},
  select(provider:Provider){if(!client)throw Error('请先选择钱包。');client.select(provider);remember(true)},
  async restore(){let remembered=false;try{remembered=localStorage.getItem(storageKey)==='1'}catch{};if(remembered&&config.walletConnect){try{await(await load()).restore()}catch{remember(false)}}},
  async disconnect(){remember(false);await client?.disconnect()},
 };
}
